<template>
  <div class="payment-header__description" :style="{ maxWidth: descriptionWidth }">
    <div class="payment-header__description__time">
      <themed-description-title v-if="description && description.length">{{ $t('purpose-of-payment') }}</themed-description-title>
      <expiresDataDescrition v-if="showExpiration && showCounter">
        <expiration-clock-svg/>
        <expires-data-descrition>&nbsp; {{ $t('remains') }}: {{ expires }}</expires-data-descrition>
      </expiresDataDescrition>
    </div>

    <themed-description-text
      v-if="description">
      {{ description }}
    </themed-description-text>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ExpirationClockSvg from "@/components/svg/ExpirationClock";
import countdown from "countdown";
import StructCaller from "@/helpers/structInterface";
import styled from "vue-styled-components";

const themedDescriptionTitle = styled.span`
  color: ${props => props.theme.on_background};
  opacity: .5;
  svg path {
    &:not(:first-child) {
      fill: ${props => props.theme.on_background};
    }
  }
  margin-right: 10px;
`;


const themedDescriptionText = styled('div', {})`
    color: ${props => props.theme.on_background};
    font-size: 16px;
    line-height: 1.25;
    margin-top: 5px;
    word-wrap: break-word;`;

const expiresDataDescrition = styled(themedDescriptionTitle)`
  color: ${props => props.theme.placeholder_text_color};
  white-space: nowrap;
  display: inline-flex;
  align-items: baseline;
  svg {
    aling-self: center;
  }
`;

export default {
  components: { ExpirationClockSvg, themedDescriptionTitle, expiresDataDescrition, themedDescriptionText , },

  data() {
    return {
      timer: null,
      showExpiration: false,
      expires: null,
      expiresDate: null,
      StructCaller
    };
  },
  computed: {
    ...mapState(["invoiceInitialData"]),
    ...mapState("UI", ["layoutConfig"]),

    showCounter() {
      return (
              !Object.entries(this.layoutConfig).length ||
              this.layoutConfig.hide_lifetime_counter !== "true"
      );
    },

    descriptionWidth() {
      if (this.screenSize.width > 1239) {
        return "650px";
      } else {
        return `${this.screenSize.width - 350}px`;
      }
    },

    description() {
      return this.invoiceInitialData.description;
    }
  },

  async created() {
    try {
      if (this.invoiceInitialData.expires) {
        await this.validateDate();
        this.timer = setInterval(() => {
          this.countDown();
          this.showExpiration = true;
        }, 1000);
      }
    } catch (e) {
      clearInterval(this.timer);
      this.setGlobalError(e);
    }
  },

  methods: {
    ...mapActions("UI", ["ADD_MESSAGE"]),
    ...mapActions(["setGlobalError"]),

    validateDate() {
      const now = new Date();
      // IF unix timestamp, we need * on 1000;

      const passedExpirationDate = new Date(
        this.invoiceInitialData.expires * 1000
      );
      this.expiresDate = passedExpirationDate;

      // Check that the date passed from query is valid
      if (
        Object.prototype.toString.call(passedExpirationDate) === "[object Date]"
      ) {
        if (isNaN(passedExpirationDate.getTime())) {
          //  Date is Invalid 👎
          return Promise.reject(
            this.StructCaller.getStructData("ERRORS", "code", "invalid_date")
          );
        } else {
          const expired = this.checkExpirationDate(this.expiresDate);

          if (expired) {
            // Already expired 👎
            return Promise.reject(
              this.StructCaller.getStructData("ERRORS", "code", "invalid_date")
            );
          } else {
            // Valid 👍
            return Promise.resolve({
              type: "success",
              isValid: true
            });
          }
        }
      } else {
        // Not a date at all.
        return Promise.reject(
          this.StructCaller.getStructData("ERRORS", "code", "invalid_date")
        );
      }
    },

    /**
     *  Check that data doesn't expired yet
     */
    checkExpirationDate(expirationDate) {
      const now = new Date();
      const expires = now - expirationDate >= 0;
      return expires;
    },

    countDown() {
      const expired = this.checkExpirationDate(this.expiresDate);
      if (!expired) {
        this.expires = countdown(
          new Date(),
          this.expiresDate,
          countdown.HOURS | countdown.MINUTES | countdown.SECONDS
        ).toString();
      } else {
        clearInterval(this.timer);
        this.setGlobalError({
          code: "date_expired"
        });
      }
    }
  }
};
</script>